import axios from 'axios';

// Create Axios instance
const api = axios.create({
  baseURL: 'https://dev-api-tracker.bhartiaxa.com/public/',
});

// Add response interceptor
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem('token');
             localStorage.removeItem("userDetails");
        localStorage.removeItem("otpValues");
        localStorage.removeItem("envType");
        window.location.reload(); // or redirect logic
      }
    } else if (error.message === 'Network Error') {
      console.log('error',error)
      console.error('Network error – possible CORS issue, offline, or timeout');
        localStorage.removeItem('token');
         localStorage.removeItem("userDetails");
        localStorage.removeItem("otpValues");
        localStorage.removeItem("envType");
        window.location.reload();

        //  localStorage.removeItem('token');
        // window.location.reload(); 
    }

    return Promise.reject(error);
  }
);

// Add request interceptor to attach token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
